import type { PlanTag } from "../../plans/PlanModel";

export type TagColor = {
  color: string;
  textColor: string;
};

// Taken from Trello
export const TagColorsAvailable = [
  { color: "#37471F", textColor: "#FFFFFF" }, // Dark Olive Green with White text
  { color: "#4C6B1F", textColor: "#FFFFFF" }, // Dark Green with White text
  { color: "#B3DF72", textColor: "#000000" }, // Light Green with Black text
  { color: "#5D1F1A", textColor: "#FFFFFF" }, // Dark Red-Brown with White text
  { color: "#AE2E24", textColor: "#FFFFFF" }, // Bright Red with White text
  { color: "#FD9891", textColor: "#000000" }, // Light Coral with Black text
  { color: "#702E00", textColor: "#FFFFFF" }, // Dark Brown-Orange with White text
  { color: "#A54800", textColor: "#FFFFFF" }, // Medium Dark Orange with White text
  { color: "#FEC195", textColor: "#000000" }, // Light Peach with Black text
  { color: "#533F04", textColor: "#FFFFFF" }, // Dark Brown with White text
  { color: "#7F5F01", textColor: "#FFFFFF" }, // Medium Brown with White text
  { color: "#F5CD47", textColor: "#000000" }, // Light Yellow with Black text
  { color: "#164B35", textColor: "#FFFFFF" }, // Dark Teal with White text
  { color: "#216E4E", textColor: "#FFFFFF" }, // Medium Teal with White text
  { color: "#7EE2B8", textColor: "#000000" }, // Light Mint with Black text
  { color: "#164555", textColor: "#FFFFFF" }, // Dark Blue-Green with White text
  { color: "#206A83", textColor: "#FFFFFF" }, // Medium Blue-Green with White text
  { color: "#9DD9EE", textColor: "#000000" }, // Light Blue with Black text
  { color: "#09326C", textColor: "#FFFFFF" }, // Dark Blue with White text
  { color: "#0055CC", textColor: "#FFFFFF" }, // Medium Blue with White text
  { color: "#85B8FF", textColor: "#000000" }, // Light Blue with Black text
  { color: "#352C63", textColor: "#FFFFFF" }, // Dark Purple with White text
  { color: "#5E4DB2", textColor: "#FFFFFF" }, // Medium Purple with White text
  { color: "#B8ACF6", textColor: "#000000" }, // Light Purple with Black text
  { color: "#50253F", textColor: "#FFFFFF" }, // Dark Maroon with White text
  { color: "#943D73", textColor: "#FFFFFF" }, // Medium Maroon with White text
  { color: "#F797D2", textColor: "#000000" }, // Light Pink with Black text
  { color: "#38414A", textColor: "#FFFFFF" }, // Dark Gray-Blue with White text
  { color: "#596773", textColor: "#FFFFFF" }, // Medium Gray-Blue with White text
  { color: "#454F59", textColor: "#FFFFFF" }, // Dark Gray with White text
  { color: "#9FADBC", textColor: "#000000" }, // Light Gray with Black text
  // biome-ignore lint/suspicious/noExplicitAny: TS is stupid
] as { color: any; textColor: any }[];

// Function to get a random color not yet used
export const getTagColorNotUsed = (tags: PlanTag[]): TagColor => {
  const usedColors = new Set(tags.map((tag) => tag.color));
  const availableColors = TagColorsAvailable.filter(
    (color) => !usedColors.has(color.color),
  );

  if (availableColors.length === 0) {
    // If all colors are used, return a random color from the available list
    return TagColorsAvailable[
      Math.floor(Math.random() * TagColorsAvailable.length)
    ];
  }

  // Return a random color from the available (not used) colors
  return availableColors[Math.floor(Math.random() * availableColors.length)];
};
